import type { SVGProps } from 'react';

const SvgChevronLargeIsolatedS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 18.008c-.26 0-.51-.1-.71-.29l-8-8a.996.996 0 1 1 1.41-1.41l7.29 7.29 7.29-7.29a.996.996 0 1 1 1.41 1.41l-8 8c-.2.2-.45.29-.71.29z"
    />
  </svg>
);
export default SvgChevronLargeIsolatedS;
